export default function DNA() {
    return (
        <>
            <div align="center">
                <h1>Et kölsche Jrundjesetz</h1>
                <h2>Das kölsche Grundgesetz / The Cologne Constitution</h2>
                <p align="center"></p>
                <h3>§01 Et es wie et es!</h3>
                German: Es ist, wie es ist!
                <br />
                English: It is like it is!
                <br />
                Meaning: Face up to the facts!
                <p></p>
                <p align="center"></p>
                <h3>§02 Et kütt wie et kütt!</h3>
                German: Es kommt, wie es kommt!
                <br />
                English: It goes like it goes!
                <br />
                Meaning: Don´t be afraid of the future!
                <p></p>
                <p align="center"></p>
                <h3>§03 Et hätt noch immer jot jejange!</h3>
                German: Es ist noch immer gut gegangen!
                <br />
                English: It always ended up well!
                <br />
                Meaning: Don’t mind, it will be okay!
                <p></p>
                <p align="center"></p>
                <h3>§04 Wat fott es es fott!</h3>
                German: Was weg ist, ist weg!
                <br />
                English: What's gone is gone !<br />
                Meaning: Don't hang on to what's gone for good!
                <p></p>
                <p align="center"></p>
                <h3>§05 Et bliev nix wie et wor!</h3>
                German: Nichts bleibt, wie es war!
                <br />
                English: Nothing remains as is!
                <br />
                Meaning: Be open to new things!
                <p></p>
                <p align="center"></p>
                <h3>§06 Kenne mer nit, bruche mer nit, fott domet!</h3>
                German: Kennen wir nicht, brauchen wir nicht, fort damit!
                <br />
                English: We don't have it, we don't need it, away with it!
                <br />
                Meaning: Keep your wits about you when things change quickly!
                <p></p>
                <p align="center"></p>
                <h3>§07 Wat wellste maache!</h3>
                German: Was willst Du machen!
                <br />
                English: What will you do!
                <br />
                Meaning: Accept your fate!
                <p></p>
                <p align="center"></p>
                <h3>§08 Mach et jot ävver nit ze off!</h3>
                German: Mach's gut aber nicht zu oft!
                <br />
                English: Make it good, but not too often!
                <br />
                Meaning: Keep all things in balance!
                <p></p>
                <p align="center"></p>
                <h3>§09 Wat sull dä Quatsch?</h3>
                German: Was soll das sinnlose Gerede?
                <br />
                English: What's this fuss about?
                <br />
                Meaning: Asking stupid questions?
                <p></p>
                <p align="center"></p>
                <h3>§10 Drinkste ene met?</h3>
                German: Trinkst Du einen mit?
                <br />
                English: Come on, have a drink?
                <br />
                Meaning: Always be hospitable!
                <p></p>
                <p align="center"></p>
                <h3>§11 Do laachste dech kapott!</h3>
                German: Da lachst Du Dich kaputt!
                <br />
                English: You laugh until you cry!
                <br />
                Meaning: Always keep your sense of humor!
                <p></p>
                <br />
                <p align="center">
                    <strong>Copyright (c) Martin Petzold (mpetzold@gmx.net)</strong>
                </p>
                <br />
                Der Inhalt dieser Seite wurde kopiert von{" "}
                <a href="http://www.jrundjesetz.koeln/">http://www.jrundjesetz.koeln/</a>
                <br/>
                The content of this page was copied from{" "}
                <a href="http://www.jrundjesetz.koeln/">http://www.jrundjesetz.koeln/</a>
            </div>
        </>
    );
}
